/*global BMS*/
import {
    HANDLE_GET_STATE_RESPONSE,
    SET_LOADING_BAR,
    SET_SERVER_TIME_OFFSET,
    SET_SERVER_TIME_ZONE_OFFSET,
    UPDATE_PLAYER_BALANCE
} from '../constants/actionTypes';
import defaultStoreValues from '../constants/defaultStoreValues';
import {getItem, setItem} from "../helpers/localStorageHelpers";
import {ODDS_TYPE, OPEN_BETS, SYS_LANGUAGE, VID_VISIBLE} from "../constants/localStorage";
import {isLocalStorageAvailable} from "../helpers/systemHelpers";
import {OPERATOR} from "../constants/operator";
import {
    _generateAccumulatorBets,
    _removeAccaSingleBets,
    _updateAccaBet,
    getUpdatedPromoBalances,
    getMajorCurrencyPromoBalances
} from '../ui-modules/sports-book/helpers/betHelpers';

export default (state, action) => {
    switch (action.type) {
        case HANDLE_GET_STATE_RESPONSE:
            let newPlacedBets = action.placedBets.sort(sortBets);
            let newSettledBets = action.settledBets.sort(sortBets);
            let initialWinValSet = true;

            let newPlayerUID;
            if (!action.isPlaceBetResponse) {
                if (!action.isFirstTimeLoad) {
                    initialWinValSet = informOperatorOfAnyPrizes(newSettledBets, state);
                }
                newPlayerUID = action.playerUID !== undefined
                    ? action.playerUID
                    : defaultStoreValues.playerUID;
            } else {
                newPlayerUID = state.playerUID
            }

            let newSystemLanguage = state.systemLanguage;
            let newSelectedOddsType = state.selectedOddsType;
            let newIsVideoVisible = state.isVideoVisible;
            let locale = JSON.parse(OPERATOR.supportedLanguages).find((lang) => lang === OPERATOR.locale.replace("-", "_"));
            if (newPlayerUID !== state.playerUID && isLocalStorageAvailable) {
                let storageSystemLaguage = getItem(newPlayerUID, SYS_LANGUAGE);
                if (storageSystemLaguage !== null) {
                    if (Array.isArray(OPERATOR.supportedLanguages)) {
                        // if by chance the configuration changed, we need to make sure that the local storage value
                        // is under the supported vales, if not, the operator default should be picked
                        newSystemLanguage = OPERATOR.supportedLanguages.find((lang) => lang === storageSystemLaguage) !== undefined ? storageSystemLaguage : locale !== undefined ? locale : OPERATOR.defaultLanguage;
                    } else {
                        newSystemLanguage = locale !== undefined ? locale : OPERATOR.defaultLanguage;
                    }
                } else {
                    newSystemLanguage = locale !== undefined ? locale : OPERATOR.defaultLanguage;
                }

                let storageSelectedOddsType = getItem(newPlayerUID, ODDS_TYPE);
                if (storageSelectedOddsType !== null) {
                    if (Array.isArray(OPERATOR.supportedOddsFormats)) {
                        // if by chance the configuration changed, we need to make sure that the local storage value
                        // is under the supported vales, if not, the operator default should be picked
                        newSelectedOddsType = OPERATOR.supportedOddsFormats.find((supOdds) => supOdds === storageSelectedOddsType) !== undefined ? storageSelectedOddsType : OPERATOR.defaultOddsFormat;
                    } else {
                        newSelectedOddsType = OPERATOR.defaultOddsFormat;
                    }
                } else {
                    newSelectedOddsType = OPERATOR.defaultOddsFormat;
                }

                let storageIsVideoVisible = getItem(newPlayerUID, VID_VISIBLE);
                if (storageIsVideoVisible !== null) {
                    newIsVideoVisible = storageIsVideoVisible;
                } else {
                    newIsVideoVisible = true;
                }
            }

            document.getElementsByTagName("html")[0].lang = newSystemLanguage;

            // open there are open bets flagged with an error, we need to filter the ones that succeeded
            let newOpenBetsList = state.openBetsList.slice();

            if (newPlacedBets !== undefined && newPlacedBets.length > 0 && newOpenBetsList !== undefined && newOpenBetsList.length > 0
                && newOpenBetsList.find((obet) => !!obet.failedCommitting)) {


                //remove single bets which is already part of a placed Acca.
                newPlacedBets.forEach(bet => {
                    if (bet.Bets.length > 1) {
                        let opaqueData = JSON.parse(bet.Bets[0].OpaqueData);
                        let uniqueId = opaqueData.uniqueId;
                        if (newOpenBetsList.indexOf(newOpenBetsList.find(sbet => sbet.bets[0].uniqueId === uniqueId)) >= 0)
                            _removeAccaSingleBets(bet, newOpenBetsList);
                    } else {
                        //update accaBets by removing placed single bets.
                        _updateAccaBet(bet, newOpenBetsList);
                    }
                });

                newOpenBetsList = newOpenBetsList.map((obet) => {
                    obet.failedCommitting = false;
                    return obet
                }).filter((obet) => {
                    return !!!newPlacedBets.find((pBet) => pBet.Bets.find((sBet) => {
                        let opaqueData = JSON.parse(sBet.OpaqueData);
                        let uniqueId = opaqueData.uniqueId;
                        return (uniqueId.toString() === obet.bets[0].uniqueId.toString());
                    }));
                });
            }


            _generateAccumulatorBets(newOpenBetsList, newOpenBetsList.slice());

            let channelEventBets = state.channelEventBets || [];

            for (var i = 0; i < newPlacedBets.length; i++) {
                let bet;
                let channel;
                let eventId;
                let opaqueData;
                if (newPlacedBets[i].Bets.length > 1) {
                    bet = newPlacedBets[i];
                    channel = bet.Bets[0].Channel;
                    eventId = bet.Bets[0].EventId;
                    opaqueData = JSON.parse(bet.Bets[0].OpaqueData);
                } else {
                    bet = newPlacedBets[i].Bets[0];
                    channel = bet.Channel
                    eventId = bet.EventId;
                    opaqueData = JSON.parse(bet.OpaqueData);
                }

                let eventBets = channelEventBets[channel] || [];
                let uniqueId = opaqueData.uniqueId;
                let betsForEvent = eventBets[eventId] || [];
                let found = false;

                for (var j = 0; j < betsForEvent.length; j++) {
                    let knownBet = betsForEvent[j];
                    let knownOpaqueData;
                    if (knownBet.Bets != undefined)
                        knownOpaqueData = JSON.parse(knownBet.Bets[0].OpaqueData);
                    else
                        knownOpaqueData = JSON.parse(knownBet.OpaqueData);
                    let knownUniqueId = knownOpaqueData.uniqueId;

                    if (knownUniqueId === uniqueId) {
                        found = true;
                        break;
                    }
                }

                if (!found) {
                    betsForEvent.push(bet);
                }

                if (channelEventBets[channel] === undefined) {
                    channelEventBets[channel] = [];
                }

                channelEventBets[channel][eventId] = betsForEvent;
            }

            let newBetHistoryBets = state.betHistoryBets;

            let recentBetHistoryBets = newPlacedBets.filter(
                placeBet => {
                    return newBetHistoryBets.find(betHistoryBet => placeBet.Bets[0].Channel === betHistoryBet.Bets[0].Channel &&
                        placeBet.Bets[0].EventId === betHistoryBet.Bets[0].EventId &&
                        placeBet.Bets[0].OpaqueData === betHistoryBet.Bets[0].OpaqueData) === undefined
                }
            );
            newBetHistoryBets = newBetHistoryBets.concat(recentBetHistoryBets);

            return {
                ...state,
                openBetsList: newOpenBetsList,
                openBetsSimpleList: newOpenBetsList.slice(),
                placedBets: newPlacedBets,
                settledBets: newSettledBets,
                playerUID: newPlayerUID,
                systemLanguage: newSystemLanguage,
                selectedOddsType: newSelectedOddsType,
                isVideoVisible: newIsVideoVisible,
                betHistoryBets: newBetHistoryBets,
                isPlatformReady: true,
                channelEventBets: channelEventBets,
                initialWinValSet: initialWinValSet
            };
        case SET_SERVER_TIME_OFFSET:
            return {
                ...state,
                serverTimeOffset: action.offset
            };
        case SET_SERVER_TIME_ZONE_OFFSET:
            return {
                ...state,
                serverTimeZoneOffset: action.serverTimeZoneOffset
            };
        case SET_LOADING_BAR:
            return {
                ...state,
                loadingBarPercentage: action.loadingBarPercentage
            };
        case UPDATE_PLAYER_BALANCE:
            let promoBalance = [];
            let boolVal = false;
            let filteredPromoBalance =[];
            let filteredOpenBetsList = [];
            if(OPERATOR.promoToolEnabled) {
                promoBalance = (action.playerBalance.PromoBalances === undefined) ? [] :action.playerBalance.PromoBalances ;
                if (promoBalance.length > 0) {
                    filteredPromoBalance =  state.promoBalances.filter((p1) => !promoBalance.some((p2)=> p1.PromoBetId.split("|")[0] === p2.PromoBetId.split("|")[0]));
                    if(filteredPromoBalance.length>0) {
                        filteredPromoBalance.map((promo) => {
                            if (promo.BalanceAmount === undefined) {
                                promoBalance.push(promo);
                            }
                        });
                    }
                    let result = promoBalance.filter(
                        (o1) => !state.promoBalances.some((o2) => o1.PromoBetId.split("|")[0] === o2.PromoBetId.split("|")[0])
                    );
                    if (result.length > 0) {
                        boolVal = true;
                    }
                }
                else{
                    state.promoBalances.map((promo) => {
                        if (promo.BalanceAmount === undefined) {
                            promoBalance.push(promo);
                        }
                    });
                }
                if (promoBalance.length >= 0) {     // PROD_VSB-6396
                    let promoMissingFromWeb = state.promoBannerFromWeb.filter((webpromo) =>
                        !promoBalance.some((promo) => webpromo.PromoBetId === promo.PromoBetId.split("|")[0])
                    );
                    if (promoMissingFromWeb.length > 0) {
                        promoMissingFromWeb.map((promo) => {
                            promoBalance.push(promo);
                        })
                    }
                    promoBalance = promoBalance.sort(function (x, y) {
                        return x.ExpireDate - y.ExpireDate;
                    })
                    //convert to major currency
                    //promoBalance = getMajorCurrencyPromoBalances(promoBalance,state.playerBalance.Banks.CREDIT.MinorCurrencyUnits);
                }

                if (OPERATOR.promoToolEnabled) {
                    //logic for manage promobet count while settling bets
                    let openBetsListData = state.openBetsList || [];
                    promoBalance = getUpdatedPromoBalances(openBetsListData, promoBalance);

                    //Filter out promos which are expired from CMS and update OPEN_BETS in localstorage
                    filteredOpenBetsList = openBetsListData.filter(o1 => o1.promo && o1.promo === 'applied' ? promoBalance.some((o2) => o1.PromoBetId === o2.PromoBetId) : true);
                    if (isLocalStorageAvailable && action.playerUID != null) {
                        localStorage.removeItem(OPEN_BETS);
                        if (filteredOpenBetsList.length !== 0) {
                            setItem(action.playerUID, OPEN_BETS, filteredOpenBetsList);
                        } else {
                            setItem(action.playerUID, OPEN_BETS, []);
                        }
                    }
                }
            }
            return {
                ...state,
                playerBalance: action.playerBalance,
                promoBalances:promoBalance,
                isGiftForYouOpen:boolVal,
                newPromoFlag:boolVal,
                openBetsList: filteredOpenBetsList.length > 0 ? filteredOpenBetsList : state.openBetsList,
                systemCurrency: action.systemCurrency ? action.systemCurrency : state.systemCurrency
            };
        default:
            return state;
    }
};

function informOperatorOfAnyPrizes(newSettledBets, state) {
    var totalPrize = 0;
    let isSettledBetResponse = false;

    if (state.initialWinValSet) {
        for (var i = 0; i < newSettledBets.length; i++) {
            let bet = newSettledBets[i].Bets[0];
            let betOpaqueData = JSON.parse(bet.OpaqueData);
            let betUniqueId = betOpaqueData.uniqueId;
            let found = false;

            for (var j = 0; j < state.settledBets.length; j++) {
                let existingBet = state.settledBets[j].Bets[0];
                let existingBetOpaqueData = JSON.parse(existingBet.OpaqueData);
                let existingBetUniqueId = existingBetOpaqueData.uniqueId;

                if (betUniqueId === existingBetUniqueId) {
                    found = true;
                    break;
                } 
            }

            if (!found) {
                isSettledBetResponse = true;
                totalPrize += bet.Prize;
            }
        }
    }

    isSettledBetResponse && BMS.Operator.updateWinnings(totalPrize);

    return true;
}

function sortBets(a, b) {
    return b.Bets[0].EventTime - a.Bets[0].EventTime;
}



// WEBPACK FOOTER //
// ./src/reducers/platformReducer.js